import { render } from "./AvoidingRenderingBouncing.vue?vue&type=template&id=3e64821e"
import script from "./AvoidingRenderingBouncing.vue?vue&type=script&lang=js"
export * from "./AvoidingRenderingBouncing.vue?vue&type=script&lang=js"
script.render = render

export default script